
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';

function Punesadeteenshaktipeeth() {



    const cardData =
    {
        keyword: ' Pune to Sade Teen Shakti Peeth Cab on Rent',
        heading: 'Prince Cabs: Pune to Sade Teen Shakti Peeth Cab on Rent',
        headingDescription: 'Prince Cabs provides dependable and affordable Pune to Sade Teen Shakti Peeth Cab on Rent service, specially designed for pilgrims, family groups, and devotees traveling for darshan. Our fleet of spacious AC and non-AC buses ensures a comfortable and safe journey from Pune to the sacred Shakti Peeth temples. With experienced drivers, well-maintained vehicles, and punctual service, we make your religious yatra peaceful and worry-free. Whether you are planning a one-day darshan trip or a group pilgrimage, Prince Cabs guarantees reliable, comfortable, and budget-friendly bus rental services for Sade Teen Shakti Peeth from Pune.',

        top: 'Top Places to Visit in Sade Teen Shakti Peeth with Prince Cabs',

"topPlaces": [
  {
    "title": "Mahalakshmi Temple, Kolhapur",
    "description": "Mahalakshmi Temple in Kolhapur is one of the Sade Teen Shakti Peeth and an important pilgrimage site in Maharashtra. Dedicated to Goddess Mahalakshmi, the temple dates back to the 7th century and showcases stunning Chalukyan architecture. The intricately carved stone walls and sanctum radiate divinity and heritage. Devotees believe that visiting this temple fulfills desires and grants prosperity. The temple complex buzzes with spiritual energy during Navratri and other festivals. It is one of the most revered Shakti Peeths for devotees across India."
  },
  {
    "title": "Tulja Bhavani Temple, Tuljapur",
    "description": "Tulja Bhavani Temple in Tuljapur, Osmanabad district, is dedicated to Goddess Bhavani, the family deity of the Marathas and the Sade Teen Shakti Peeth. It holds deep significance as Chhatrapati Shivaji Maharaj sought blessings from the Goddess before major campaigns. Built in the 12th century, the temple’s stone architecture, powerful idol, and grand entrance leave devotees in awe. The shrine attracts lakhs of pilgrims every year, especially during Navratri. It is a symbol of strength, courage, and devotion."
  },
  {
    "title": "Renuka Devi Temple, Mahur",
    "description": "Renuka Devi Temple in Mahur, Nanded district, is dedicated to Goddess Renuka, mother of Lord Parashurama. Recognized as part of the Sade Teen Shakti Peeth, this temple sits atop a picturesque hill surrounded by lush forests. The holy site has been a center of worship for centuries, offering peace and devotion to visitors. Pilgrims believe that seeking blessings here helps in family well-being and removes obstacles. The panoramic views from the temple add a spiritual calmness to the visit. It is a must-visit for devotees on the Shakti Peeth yatra."
  },
  {
    "title": "Saptashrungi Temple, Vani (Half Shakti Peeth)",
    "description": "Saptashrungi Temple in Nashik district is revered as the 'Ardh' or half Shakti Peeth among the Sade Teen Shakti Peeth. Dedicated to Goddess Saptashrungi Nivasini, the temple is located on a mountain surrounded by seven hills, hence its name. The idol of the Goddess is carved into a rock and decorated beautifully with sindoor. Pilgrims climb hundreds of steps or use ropeway facilities to reach the shrine, making the journey spiritually enriching. The temple is especially vibrant during Navratri when thousands gather for darshan. It embodies devotion, power, and nature’s magnificence."
  }
],


"services": [
  {
    "name": "Pune to Sade Teen Shakti Peeth Bus Hire",
    "description": "Prince Cabs offers reliable Pune to Sade Teen Shakti Peeth bus hire services for pilgrims, families, and groups. Our fleet of spacious buses ensures safe travel with AC comfort, expert drivers, and on-time departures. Whether for one-day darshan or extended yatras, we make your journey devotional and worry-free."
  },
  {
    "name": "Sade Teen Shakti Peeth Bus Rental Pune",
    "description": "Book well-maintained buses on rent from Pune to Sade Teen Shakti Peeth with Prince Cabs. Designed for large groups, our rental service provides affordable fares, comfortable seating, and flexible booking options. Perfect for religious yatras, tours, and pilgrim groups seeking convenient transport."
  },
  {
    "name": "Pune Pilgrimage Bus Sade Teen Shakti Peeth",
    "description": "Our Pune pilgrimage bus service to Sade Teen Shakti Peeth is tailored for devotees. Enjoy smooth intercity travel in AC or luxury buses with professional chauffeurs and ample luggage space. The service ensures safe and devotional journeys to Kolhapur, Tuljapur, Mahur, and Vani temples."
  },
  {
    "name": "Sade Teen Shakti Peeth Group Bus Pune",
    "description": "Hire group buses from Pune to Sade Teen Shakti Peeth for community yatras and pilgrim tours. Prince Cabs offers buses with spacious seating, flexible schedules, and affordable group fares. Ideal for temples visits with family, friends, or spiritual organizations."
  },
  {
    "name": "Pune AC Bus to Sade Teen Shakti Peeth",
    "description": "Travel in comfort with fully air-conditioned buses from Pune to Sade Teen Shakti Peeth. Our AC buses ensure a cool and pleasant ride across long distances while maintaining punctuality and safety. A perfect choice for devotees traveling during summer or festival seasons."
  },
  {
    "name": "Luxury Bus to Sade Teen Shakti Peeth Pune",
    "description": "For those seeking premium travel, Prince Cabs provides luxury buses to Sade Teen Shakti Peeth from Pune. With plush interiors, superior legroom, and modern amenities, our luxury buses redefine comfort for pilgrimage tours and special religious trips."
  },
  {
    "name": "Sade Teen Shakti Peeth Bus Booking Pune",
    "description": "Prince Cabs makes it easy to book buses from Pune to Sade Teen Shakti Peeth with instant confirmation. Choose from AC, non-AC, or luxury buses depending on your group size and budget. Hassle-free booking ensures peace of mind for your religious yatra."
  },
  {
    "name": "Pune Shuttle Bus Sade Teen Shakti Peeth",
    "description": "Our shuttle bus service from Pune to Sade Teen Shakti Peeth is ideal for small groups and families. With multiple seating options and cost-effective fares, Prince Cabs ensures reliable, safe, and devotional travel experiences to all Shakti Peeth temples."
  },
  {
    "name": "Pune Tour Bus Sade Teen Shakti Peeth",
    "description": "Explore all sacred Shakti Peeth temples with our dedicated Pune tour bus packages. Prince Cabs organizes well-planned itineraries, comfortable seating, and professional drivers for a complete pilgrimage experience covering Kolhapur, Tuljapur, Mahur, and Vani."
  },
  {
    "name": "Pune Sade Teen Shakti Peeth Bus Fare",
    "description": "Check transparent bus fare options from Pune to Sade Teen Shakti Peeth with Prince Cabs. No hidden costs—only affordable packages tailored to your group size and bus type, including AC, luxury, or standard buses."
  },
  {
    "name": "Pune Religious Bus Sade Teen Shakti Peeth",
    "description": "Prince Cabs offers religious bus services from Pune to Sade Teen Shakti Peeth, ensuring devotional ambiance and group-friendly travel. Our buses are equipped with comfortable seating and experienced drivers for safe and peaceful journeys."
  },
  {
    "name": "Sade Teen Shakti Peeth Group Travel Bus Pune",
    "description": "For large groups, our dedicated buses provide spacious seating, ample luggage space, and budget-friendly fares. Prince Cabs ensures smooth group travel from Pune to Sade Teen Shakti Peeth temples, making pilgrimages comfortable and memorable."
  },
  {
    "name": "Pune to Sade Teen Shakti Peeth Cab on Rent",
    "description": "Hire buses on rent from Pune to Sade Teen Shakti Peeth for family trips, group pilgrimages, and temple visits. Prince Cabs offers flexible schedules, AC comfort, and reliable drivers, ensuring your yatra is smooth and stress-free."
  },
  {
    "name": "Pune Sade Teen Shakti Peeth Bus Package",
    "description": "Prince Cabs provides complete pilgrimage bus packages from Pune to Sade Teen Shakti Peeth. The package includes round-trip travel, multiple temple visits, and customized itineraries, making it perfect for spiritual journeys and group darshans."
  },
  {
    "name": "Sade Teen Shakti Peeth Bus for Events Pune",
    "description": "Book event-special buses from Pune to Sade Teen Shakti Peeth for religious gatherings, Navratri yatras, and group festivals. Our buses are equipped for large group travel, ensuring comfort, safety, and affordable rentals for every occasion."
  }
],
"tableData": [
  ["Pune to Sade Teen Shakti Peeth Bus Hire", "Sade Teen Shakti Peeth Bus Rental Pune"],
  ["Pune Pilgrimage Bus Sade Teen Shakti Peeth", "Sade Teen Shakti Peeth Group Bus Pune"],
  ["Pune AC Bus to Sade Teen Shakti Peeth", "Luxury Bus to Sade Teen Shakti Peeth Pune"],
  ["Sade Teen Shakti Peeth Bus Booking Pune", "Pune Shuttle Bus Sade Teen Shakti Peeth"],
  ["Pune Tour Bus Sade Teen Shakti Peeth", "Pune Sade Teen Shakti Peeth Bus Fare"],
  ["Pune Religious Bus Sade Teen Shakti Peeth", "Sade Teen Shakti Peeth Group Travel Bus Pune"],
  ["Pune to Sade Teen Shakti Peeth Cab on Rent", "Pune Sade Teen Shakti Peeth Bus Package"],
  ["Sade Teen Shakti Peeth Bus for Events Pune"]
],

"whychoose": [
  {
    "WhyChooseheading": "Trusted Bus Rentals for Sade Teen Shakti Peeth Yatra",
    "WhyChoosedescription": "Prince Cabs offers reliable bus rental services from Pune for the sacred Sade Teen Shakti Peeth pilgrimage. With years of experience in handling group travel for religious yatras, we ensure punctuality, safety, and comfort. Devotees can focus on their spiritual journey while we take care of seamless travel arrangements."
  },
  {
    "WhyChooseheading": "Spacious Buses for Groups and Families",
    "WhyChoosedescription": "Our fleet includes a wide range of buses such as AC, non-AC, mini buses, and luxury coaches to suit every group size. Whether you are a small family, a large community group, or an organization planning a pilgrimage, our buses provide spacious seating and ample luggage capacity for a stress-free journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Bus Fare",
    "WhyChoosedescription": "We offer transparent and budget-friendly pricing for Pune to Sade Teen Shakti Peeth bus rentals. No hidden charges—fares include fuel, tolls, and driver allowance. Our packages are designed to be economical while providing maximum comfort, making pilgrimages accessible to everyone."
  },
  {
    "WhyChooseheading": "Comfortable Travel with AC and Luxury Options",
    "WhyChoosedescription": "Experience hassle-free travel with our modern AC and luxury buses equipped with reclining seats, clean interiors, and on-road assistance. For groups seeking a premium travel experience, our luxury coaches with enhanced legroom and comfort are the perfect choice for long spiritual journeys."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our drivers are experienced, background-verified, and trained to handle long intercity routes with care. They prioritize passenger safety and punctuality, ensuring devotees reach Kolhapur, Tuljapur, Mahur, and Vani comfortably. Courteous service and local route expertise make the journey pleasant and reliable."
  },
  {
    "WhyChooseheading": "Customized Pilgrimage Packages",
    "WhyChoosedescription": "Prince Cabs provides tailor-made packages for Pune to Sade Teen Shakti Peeth yatras, covering Mahalakshmi Temple, Tulja Bhavani, Renuka Devi, and Saptashrungi Devi. Whether you want a one-day darshan trip or a multi-day group tour, we create schedules that align with your spiritual needs."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and Assistance",
    "WhyChoosedescription": "With round-the-clock booking support, Prince Cabs ensures a smooth planning process for your pilgrimage. Our team assists with quick bookings, route planning, and emergency support. From first inquiry to return journey, we are available at every step to provide a reliable travel experience."
  }
]
























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide bus rental service from Pune to Sade Teen Shakti Peeth?',
        answer: 'Yes, Prince Cabs offers reliable AC and luxury bus rental services from Pune to Sade Teen Shakti Peeth, ideal for family groups, devotees, and pilgrimage tours.',
    },
    {
        question: 'What types of buses are available for the Sade Teen Shakti Peeth yatra?',
        answer: 'We provide a wide range of options including AC buses, non-AC buses, mini buses, and luxury coaches to suit different group sizes and budgets.',
    },
    {
        question: 'How many temples are covered in the Pune to Sade Teen Shakti Peeth bus service?',
        answer: 'Our service covers all four temples – Mahalakshmi (Kolhapur), Tulja Bhavani (Tuljapur), Renuka Devi (Mahur), and Saptashrungi (Vani – half Shakti Peeth).',
    },
    {
        question: 'Can I pre-book a bus for Sade Teen Shakti Peeth from Pune?',
        answer: 'Yes, you can pre-book your bus through our website or by contacting our customer support team to ensure a smooth and planned pilgrimage journey.',
    },
    {
        question: 'Are the buses clean and suitable for long-distance religious travel?',
        answer: 'Absolutely! All our buses are well-maintained, regularly sanitized, and equipped with comfortable seating to ensure a safe and peaceful pilgrimage.',
    },
    {
        question: 'What is the bus fare from Pune to Sade Teen Shakti Peeth?',
        answer: 'Fares vary based on the type of bus and group size. Prince Cabs ensures transparent and competitive pricing with no hidden charges.',
    },
    {
        question: 'Do you provide group travel and package options?',
        answer: 'Yes, we offer customized group packages that include complete darshan itineraries for devotees traveling together from Pune to Sade Teen Shakti Peeth.',
    },
    {
        question: 'Is bus service available during festivals and peak pilgrimage seasons?',
        answer: 'Yes, Prince Cabs operates dedicated bus services during Navratri, Diwali, and other festival seasons, ensuring timely and convenient temple visits.',
    },
];

const testimonials = [
    {
        name: "Mr. Sanjay Deshmukh",
        position: "Pilgrim Traveler",
        text: "We booked a bus from Pune to Sade Teen Shakti Peeth with Prince Cabs, and the experience was excellent. The driver was polite, and the bus was clean and comfortable for our entire group.",
        image: "/img/testimonial/testimonial-thumb-sadeteen-1.png",
    },
    {
        name: "Mrs. Kavita Joshi",
        position: "Family Group Traveler",
        text: "Our family yatra to Sade Teen Shakti Peeth was smooth and peaceful thanks to Prince Cabs. The AC bus was spacious, and the itinerary covered all the temples perfectly.",
        image: "/img/testimonial/testimonial-thumb-sadeteen-2.png",
    },

];







































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune Sade Teen Shakti Peeth Cab on Rent",
  "description": "Prince Cabs offers dependable Pune Sade Teen Shakti Peeth Cab on Rent services, designed for pilgrims, families, and group travelers. Our fleet includes AC buses, non-AC buses, mini buses, and luxury coaches for comfortable journeys covering Kolhapur, Tuljapur, Mahur, and Vani temples. With professional drivers, timely departures, and transparent fares, we ensure a smooth and devotional yatra from Pune.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91 9284304420",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "5823"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune to Sade Teen Shakti Peeth Cab on Rent | Prince Cabs</title>
  <meta
    name="description"
    content="Book Pune Sade to Teen Shakti Peeth Cab on Rent with Prince Cabs. Choose AC, non-AC, or luxury buses for pilgrimages to Kolhapur, Tuljapur, Mahur, and Vani. Affordable fares, group packages, and reliable service."
  />
  <meta
    name="keywords"
    content="Pune to Sade Teen Shakti Peeth bus hire, Sade Teen Shakti Peeth bus rental Pune, Pune pilgrimage bus Sade Teen Shakti Peeth, Sade Teen Shakti Peeth group bus Pune, Pune AC bus to Sade Teen Shakti Peeth, luxury bus to Sade Teen Shakti Peeth Pune, Sade Teen Shakti Peeth bus booking Pune, Pune shuttle bus Sade Teen Shakti Peeth, Pune tour bus Sade Teen Shakti Peeth, Pune Sade Teen Shakti Peeth bus fare, Pune religious bus Sade Teen Shakti Peeth, Sade Teen Shakti Peeth group travel bus Pune, Pune to Sade Teen Shakti Peeth Cab on Rent, Pune Sade Teen Shakti Peeth bus package, Sade Teen Shakti Peeth bus for events Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/85.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punesadeteenshaktipeeth ;